const headerDataTow = [{
		prop: 'id',
		label: '序号',
		columnwidth: 50
	},
	// {
	//   prop: 'StatusName',
	//   label: '状态',
	//   columnwidth: 80
	// },
	{
		prop: "InvoiceCheckedName",
		label: "状态",
		columnwidth: 130,
	},
	{
		prop: 'InvoiceNo',
		label: '发票号码',
		columnwidth: 120
	},
	{
		prop: 'SBDate',
		label: '发票日期',
		columnwidth: 100
	},
	{
		prop: 'SBMonth',
		label: '发票年月',
		columnwidth: 100
	},
	{
		prop: 'CreateOrgName',
		label: '开票方',
		columnwidth: 230
	},
	{
		prop: 'CusName',
		label: '付款方',
		columnwidth: 210
	},
	{
		prop: 'HosType',
		label: '付款方类型',
		columnwidth: 130
	},
	{
		prop: 'TerminalHPName',
		label: '终端医院',
		columnwidth: 160
	},
	{
		prop: "TechnicalOffices",
		label: "院区/科室",
		columnwidth: 120
	},
	{
		prop: 'TerminalHPCode',
		label: '医院编码',
		columnwidth: 100
	},
	{
		prop: 'ProvinceName',
		label: '省份',
		columnwidth: 80
	},
	{
		prop: 'CityName',
		label: '城市',
		columnwidth: 80
	},
	{
		prop: 'DistrictName',
		label: '区县',
		columnwidth: 80
	},
	{
		prop: 'SalesMan',
		label: '销售人员',
		columnwidth: 170
	},
	{
		prop: "ProvinceMan",
		label: "省级经理",
		columnwidth: 200
	},
	{
		prop: 'AreaMan',
		label: '地区经理',
		columnwidth: 100
	},
	{
		prop: 'RegionMan',
		label: '大区经理',
		columnwidth: 100
	},
	{
		prop: 'CountryMan',
		label: '全国总监',
		columnwidth: 100
	},

	{
		prop: 'InvAddCode',
		label: '产品代码',
		columnwidth: 140
	},
	{
		prop: 'InvName',
		label: '产品名称',
		columnwidth: 150
	},
	{
		prop: 'Batch',
		label: '批号',
		columnwidth: 130
	},
	{
		prop: 'ValiDate',
		label: '失效日期',
		columnwidth: 100
	},
	{
		prop: 'UnitName',
		label: '单位',
		columnwidth: 80
	},
	{
		prop: 'Quantity',
		label: '数量',
		columnwidth: 80
	},
	{
		prop: 'TaxUnitPrice',
		label: '含税单价',
		columnwidth: 80
	},
	{
		prop: 'Sum',
		label: '价税合计',
		columnwidth: 80
	},
	{
		prop: 'InvClassName',
		label: '产品线',
		columnwidth: 80
	},
	{
		prop: 'LEVEL1',
		label: 'LEVEL1',
		columnwidth: 120
	},
	{
		prop: 'LEVEL2',
		label: 'LEVEL2',
		columnwidth: 120
	},
	{
		prop: 'LEVEL3',
		label: 'LEVEL3',
		columnwidth: 120
	},
	{
		prop: 'LEVEL4',
		label: 'LEVEL4',
		columnwidth: 120
	},
	{
		prop: 'StandardCost',
		label: '参考价格',
		columnwidth: 120
	},
	{
		prop: 'StandardSum',
		label: '参考价格合计',
		columnwidth: 120
	},
	{
		prop: 'ErrMessage',
		label: '报错信息',
		columnwidth: 120
	},
	// {
	//   prop: 'CheckedRemark',
	//   label: '发票标注内容',
	//   columnwidth: 320
	// },
	{
		prop: 'CreateTime',
		label: '上传日期',
		columnwidth: 120
	},
]
export default headerDataTow;